/* tslint:disable */
/* eslint-disable */
/**
 * MAPIIO API
 * API mapové aplikace Mapiio pro klientskou JavaScriptovou / React část.
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



    /**
 * Strategie načítání features vrstvy.
 * @export
 * @enum {string}
 */

export const LoadingStrategy = {
    ALL: 'all',
    BBOX: 'bbox',
    USER_COORDINATE: 'user-coordinate',
    JSON: 'json'
} as const;

export type LoadingStrategy = typeof LoadingStrategy[keyof typeof LoadingStrategy];



